import { components } from "@opstel/gen/api/v2";
import { Duration } from "luxon";
import { z } from "zod";
import { durationSchema } from "../utils/dateTime";

export interface Route {
  id: string;
  preference: number;
  drivingTime: Duration<true>;
  tracks: string[];
}

export const routeSchema = z.object({
  id: z.uuid(),
  preference: z.number(),
  drivingTime: durationSchema,
  tracks: z.array(z.string()),
}) satisfies z.ZodType<Route, components["schemas"]["Route"]>;
